import { AuthApi } from '../infrastructure/authApi';
import { AuthStorage } from '../infrastructure/authStorage';

export class LogoutUseCase {
  private authApi: AuthApi;
  private authStorage: AuthStorage;

  constructor() {
    this.authApi = new AuthApi();
    this.authStorage = new AuthStorage();
  }

  async execute(): Promise<void> {
    const refreshToken = this.authStorage.getRefreshToken();
    if (refreshToken) {
      await this.authApi.logout(refreshToken);
    }
    this.authStorage.clearAuthData();
  }
}

